export default __webpack_public_path__ + "static/media/Banner1.ff479413.svg";